import { UsersTable } from '@/components/admin/users-table';
import { ensureSession } from '@/lib/session';
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_authed/admin/users')({
  beforeLoad: async ({ context }) => {
    const state = await ensureSession(context.queryClient);
    if (state.status !== 'authenticated') throw redirect({ to: '/signin' });
    if (state.session.role !== 'admin') throw redirect({ to: '/admin/feedback' });
  },
  component: AdminUsersRoute,
});

function AdminUsersRoute() {
  return <UsersTable />;
}
